import React, { useState } from 'react';

const RAW_CALENDAR_EVENTS = [
    // Lord Brighton College BMT Tournament
    {
      id: 'bmt-2026-04-21',
      date: '2026-04-21T12:00:00',
      title: "Lord Brighton BMT — Tigers vs St George's Dragons",
      time: '3:00 pm',
      location: 'Lord Brighton College',
      type: 'tournament',
    },
    {
      id: 'bmt-2026-04-23',
      date: '2026-04-23T12:00:00',
      title: 'Lord Brighton BMT — Tigers vs Manoradere High',
      time: '2:00 pm',
      location: 'Lord Brighton College',
      type: 'tournament',
    },
    {
      id: 'bmt-2026-04-25',
      date: '2026-04-25T12:00:00',
      title: 'Lord Brighton BMT — Tigers vs Lord Brighton',
      time: '2:00 pm',
      location: 'Lord Brighton College',
      type: 'tournament',
    },
    // Mukuru Derby Day (27 Apr – 3 May 2026)
    {
      id: 'mukuru-2026-04-28',
      date: '2026-04-28T12:00:00',
      title: 'Mukuru Derby Day — 2nd XV vs Peterhouse 2nd XV',
      time: 'Time TBC',
      location: "St John's College",
      type: 'tournament',
    },
    {
      id: 'mukuru-2026-04-30',
      date: '2026-04-30T12:00:00',
      title: "Mukuru Derby Day — Tigers vs St John's College Rams",
      time: '3:40 pm',
      location: "St John's College",
      type: 'tournament',
    },
    {
      id: 'mukuru-2026-05-02',
      date: '2026-05-02T12:00:00',
      title: 'Mukuru Derby Day — Tigers vs Churchill Bulldogs',
      time: '1:00 pm',
      location: "St John's College",
      type: 'tournament',
    },
    // Season games
    {
      id: 'season-2026-05-16',
      date: '2026-05-16T12:00:00',
      title: "vs St John's College",
      time: 'Time TBC',
      location: 'Away',
      type: 'match',
    },
    {
      id: 'season-2026-05-23',
      date: '2026-05-23T12:00:00',
      title: 'vs Churchill',
      time: 'Time TBC',
      location: 'Away',
      type: 'match',
    },
    {
      id: 'season-2026-05-30',
      date: '2026-05-30T12:00:00',
      title: "vs St Ignatius",
      time: 'Time TBC',
      location: 'Home',
      type: 'match',
    },
    {
      id: 'season-2026-06-06',
      date: '2026-06-06T12:00:00',
      title: 'vs Hillcrest',
      time: 'Time TBC',
      location: 'Away',
      type: 'match',
    },
    {
      id: 'season-2026-06-13',
      date: '2026-06-13T12:00:00',
      title: 'vs Plumtree',
      time: 'Time TBC',
      location: 'Home',
      type: 'match',
    },
    {
      id: 'season-2026-06-27',
      date: '2026-06-27T12:00:00',
      title: 'vs Eaglesvale',
      time: 'Time TBC',
      location: 'Home',
      type: 'match',
    },
    {
      id: 'season-2026-07-01',
      date: '2026-07-01T12:00:00',
      title: 'vs Milton',
      time: 'Time TBC',
      location: 'Home',
      type: 'match',
    },
    {
      id: 'season-2026-07-04',
      date: '2026-07-04T12:00:00',
      title: 'Peterhouse 7s',
      time: 'Time TBC',
      location: 'Away',
      type: 'match',
    },
    {
      id: 'season-2026-07-11',
      date: '2026-07-11T12:00:00',
      title: 'vs Wise Owl',
      time: 'Time TBC',
      location: 'Home',
      type: 'match',
    },
    {
      id: 'season-2026-07-18',
      date: '2026-07-18T12:00:00',
      title: "vs St George's College",
      time: 'Time TBC',
      location: 'Away',
      type: 'match',
    },
    {
      id: 'season-2026-07-25',
      date: '2026-07-25T12:00:00',
      title: 'vs Peterhouse',
      time: 'Time TBC',
      location: 'Away',
      type: 'match',
    },
    {
      id: 'season-2026-08-01',
      date: '2026-08-01T12:00:00',
      title: 'vs Lomagudi College',
      time: 'Time TBC',
      location: 'Home',
      type: 'match',
    },
];

const CALENDAR_EVENTS = [...RAW_CALENDAR_EVENTS].sort(
  (a, b) => new Date(a.date) - new Date(b.date)
);

const Calendar = () => {
  const festivalEvents = CALENDAR_EVENTS.filter(
    (e) => e.type === 'tournament'
  );
  const seasonEvents = CALENDAR_EVENTS.filter((e) => e.type === 'match');

  const [activeTab, setActiveTab] = useState('festivals');

  const getEventTypeColor = (type) => {
    switch(type) {
      case 'match':
        return 'var(--maroon)';
      case 'tournament':
        return 'var(--green)';
      case 'training':
        return '#666';
      default:
        return 'var(--text-gray)';
    }
  };

  const getEventTypeLabel = (type) => {
    switch(type) {
      case 'match':
        return 'Match';
      case 'tournament':
        return 'Tournament';
      case 'training':
        return 'Training';
      default:
        return 'Event';
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'short', 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const locationIcon = (location) => {
    if (location === 'Away') return '🚌';
    if (location === 'Home') return '🏠';
    return '📍';
  };

  const renderEventList = (list) =>
    list.map((event) => (
      <div key={event.id} className="event-card">
        <div
          className="event-date-badge"
          style={{ borderColor: getEventTypeColor(event.type) }}
        >
          <div className="event-day">{new Date(event.date).getDate()}</div>
          <div className="event-month">
            {new Date(event.date).toLocaleDateString('en-US', {
              month: 'short',
            })}
          </div>
        </div>
        <div className="event-details">
          <div className="event-header">
            <h3 className="event-title">{event.title}</h3>
            <span
              className="event-type"
              style={{ backgroundColor: getEventTypeColor(event.type) }}
            >
              {getEventTypeLabel(event.type)}
            </span>
          </div>
          <div className="event-info">
            <p className="event-date-full">{formatDate(event.date)}</p>
            <p className="event-time">⏰ {event.time}</p>
            <p className="event-location">
              {locationIcon(event.location)} {event.location}
            </p>
          </div>
        </div>
      </div>
    ));

  const hasAnyFixtures = CALENDAR_EVENTS.length > 0;

  return (
    <section id="calendar" className="section calendar-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Upcoming Events & Fixtures</h2>
          <div className="title-underline"></div>
        </div>
        <div className="calendar-content">
          {hasAnyFixtures ? (
            <>
              <div
                className="fixture-tabs"
                role="tablist"
                aria-label="Fixture categories"
              >
                <button
                  type="button"
                  role="tab"
                  id="tab-festivals"
                  aria-selected={activeTab === 'festivals'}
                  aria-controls="panel-festivals"
                  className={`fixture-tab${activeTab === 'festivals' ? ' fixture-tab--active' : ''}`}
                  onClick={() => setActiveTab('festivals')}
                >
                  Festivals
                </button>
                <button
                  type="button"
                  role="tab"
                  id="tab-season"
                  aria-selected={activeTab === 'season'}
                  aria-controls="panel-season"
                  className={`fixture-tab${activeTab === 'season' ? ' fixture-tab--active' : ''}`}
                  onClick={() => setActiveTab('season')}
                >
                  Season
                </button>
              </div>
              <div
                id="panel-festivals"
                role="tabpanel"
                aria-labelledby="tab-festivals"
                hidden={activeTab !== 'festivals'}
                className="fixture-tab-panel"
              >
                {festivalEvents.length > 0 ? (
                  <div className="events-list">
                    {renderEventList(festivalEvents)}
                  </div>
                ) : (
                  <div className="no-events no-events--compact">
                    <p>No festival fixtures listed yet.</p>
                  </div>
                )}
              </div>
              <div
                id="panel-season"
                role="tabpanel"
                aria-labelledby="tab-season"
                hidden={activeTab !== 'season'}
                className="fixture-tab-panel"
              >
                {seasonEvents.length > 0 ? (
                  <div className="events-list">
                    {renderEventList(seasonEvents)}
                  </div>
                ) : (
                  <div className="no-events no-events--compact">
                    <p>No season fixtures listed yet.</p>
                  </div>
                )}
              </div>
            </>
          ) : (
            <div className="no-events">
              <div className="no-events-icon">📅</div>
              <h3>No Current Fixtures</h3>
              <p>Fixtures and events will be posted here when available. Please check back soon or contact us for more information.</p>
            </div>
          )}
          <div className="calendar-note">
            <p>📅 <strong>Note:</strong> Fixtures and events are subject to change. Please check with the school for the most up-to-date information.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Calendar;

